import React, { useState, useEffect } from "react";
import axiosAuth from "../../../utils/axiosWithAuth";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Chip,
  Button,
  Link,
  Tooltip
} from "@material-ui/core";
import {Link as RouterLink} from 'react-router-dom'
import AuthorizationAppBar from "./AuthorizationAppBar"
import AuthorizationStatusChip from "./AuthorizationStatusChip"

export default function AuthorizationIndex() {
  const [authorizations, setAuthorizations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [companyUuid, setCompanyUuid] = useState(null);

  useEffect(() => {
    axiosAuth()
      .get("/authorizations")
      .then((r) => {
        console.log("response from /authorizations", r)
        setAuthorizations(r.data.authorizations);
        setCompanyUuid(r.data.companyUuid)
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div>
      <AuthorizationAppBar />
      <div style={{padding: 24}}>
      <div style={{display: 'flex', justifyContent: "space-between", alignItems: 'center', marginBottom: 24}}>

      <Typography variant="h3">
        Manage Authorizations
      </Typography>
      {companyUuid ? 
      <Tooltip title="Share and complete this form to create authorizations and activate your utility accounts for intake and tracking.">
        <div style={{display: 'flex'}}>
          <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Create New Authorization:&nbsp;
          <Link href={`${process.env.REACT_APP_URL}/credentials-transfer/${companyUuid}`} target="_blank" rel="noopener noreferrer">
            {`${process.env.REACT_APP_URL}/credentials-transfer/${companyUuid}`}
          </Link>
          </Typography>
        </div>
      </Tooltip>
      : <span>Loading...</span>}
      </div>
      {isLoading ? (
        <CircularProgress />
      ) : authorizations.length === 0 ? (
        <Typography>No authorizations found.</Typography>
      ) : (
        <TableContainer component={Paper} elevation={4}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="right">ID</TableCell>
                <TableCell>Online Access URL</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {authorizations.map((auth) => (
                <TableRow key={auth.id}>
                  <TableCell align="right">{auth.id}</TableCell>
                  <TableCell>
                    <span
                      href={auth.online_access_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {auth.online_access_url}
                    </span>
                  </TableCell>
                  <TableCell>{auth.online_access_username}</TableCell>
                  <TableCell>
                    <AuthorizationStatusChip status={auth.status}/>
                  </TableCell>
                  <TableCell>
                    <RouterLink to={`/${process.env.REACT_APP_MODE == "invoiage" ? "documents" : "invoiage"}/authorizations/${auth.id}`}>
                      <Button variant='outlined'>Manage</Button>
                    </RouterLink>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      </div>
    </div>
  );
}